import { useEmployeeActions } from "../actions/employeeActions"
import { useEmployeeBuilders } from "../builders/employeeBuilders"
import { useEmployeeLoaders } from "../loaders/employeeLoaders"

export const useEmployeeService = () => {
    const { buildEmployee } = useEmployeeBuilders()

    const employeeLoaders = useEmployeeLoaders()

    const { saveEmployee } = useEmployeeActions()

    const archiveEmployee = async (employeeId: string) => {
        const { loadEmployee } = employeeLoaders()
        const employee = await loadEmployee(employeeId, true)
        const archivedEmployee = buildEmployee({
            ...employee,
            archived: true
        })
        return saveEmployee(archivedEmployee)
    }

    return {
        archiveEmployee
    }
}
